module.exports = __webpack_public_path__ + "img/1A12C3820DA9CBD6.24d3d3ad.png";